/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemArSessionStatusFromJSON(json) {
    return WallItemArSessionStatusFromJSONTyped(json, false);
}
export function WallItemArSessionStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cameraTrackingStatus': !exists(json, 'camera_tracking_status') ? undefined : json['camera_tracking_status'],
        'cameraTrackingPausedReason': !exists(json, 'camera_tracking_paused_reason') ? undefined : json['camera_tracking_paused_reason'],
        'worldMappingStatus': !exists(json, 'world_mapping_status') ? undefined : json['world_mapping_status'],
    };
}
export function WallItemArSessionStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'camera_tracking_status': value.cameraTrackingStatus,
        'camera_tracking_paused_reason': value.cameraTrackingPausedReason,
        'world_mapping_status': value.worldMappingStatus,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArSessionStatusCameraTrackingStatus;
(function (WallItemArSessionStatusCameraTrackingStatus) {
    WallItemArSessionStatusCameraTrackingStatus["NORMAL"] = "CAMERA_TRACKING_STATUS_NORMAL";
    WallItemArSessionStatusCameraTrackingStatus["PAUSED"] = "CAMERA_TRACKING_STATUS_PAUSED";
    WallItemArSessionStatusCameraTrackingStatus["STOPPED"] = "CAMERA_TRACKING_STATUS_STOPPED";
})(WallItemArSessionStatusCameraTrackingStatus || (WallItemArSessionStatusCameraTrackingStatus = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArSessionStatusCameraTrackingPausedReason;
(function (WallItemArSessionStatusCameraTrackingPausedReason) {
    WallItemArSessionStatusCameraTrackingPausedReason["BADSTATE"] = "CAMERA_TRACKING_PAUSED_REASON_BAD_STATE";
    WallItemArSessionStatusCameraTrackingPausedReason["CAMERAUNAVAILABLE"] = "CAMERA_TRACKING_PAUSED_REASON_CAMERA_UNAVAILABLE";
    WallItemArSessionStatusCameraTrackingPausedReason["EXCESSIVEMOTION"] = "CAMERA_TRACKING_PAUSED_REASON_EXCESSIVE_MOTION";
    WallItemArSessionStatusCameraTrackingPausedReason["INITIALIZING"] = "CAMERA_TRACKING_PAUSED_REASON_INITIALIZING";
    WallItemArSessionStatusCameraTrackingPausedReason["INSUFFICIENTFEATURES"] = "CAMERA_TRACKING_PAUSED_REASON_INSUFFICIENT_FEATURES";
    WallItemArSessionStatusCameraTrackingPausedReason["INSUFFICIENTLIGHT"] = "CAMERA_TRACKING_PAUSED_REASON_INSUFFICIENT_LIGHT";
    WallItemArSessionStatusCameraTrackingPausedReason["RELOCALIZING"] = "CAMERA_TRACKING_PAUSED_REASON_RELOCALIZING";
    WallItemArSessionStatusCameraTrackingPausedReason["UNKNOWN"] = "CAMERA_TRACKING_PAUSED_REASON_UNKNOWN";
})(WallItemArSessionStatusCameraTrackingPausedReason || (WallItemArSessionStatusCameraTrackingPausedReason = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArSessionStatusWorldMappingStatus;
(function (WallItemArSessionStatusWorldMappingStatus) {
    WallItemArSessionStatusWorldMappingStatus["EXTENDING"] = "WORLD_MAPPING_STATUS_EXTENDING";
    WallItemArSessionStatusWorldMappingStatus["INITIALIZING"] = "WORLD_MAPPING_STATUS_INITIALIZING";
    WallItemArSessionStatusWorldMappingStatus["LIMITED"] = "WORLD_MAPPING_STATUS_LIMITED";
    WallItemArSessionStatusWorldMappingStatus["MAPPED"] = "WORLD_MAPPING_STATUS_MAPPED";
    WallItemArSessionStatusWorldMappingStatus["UNKNOWN"] = "WORLD_MAPPING_STATUS_UNKNOWN";
})(WallItemArSessionStatusWorldMappingStatus || (WallItemArSessionStatusWorldMappingStatus = {}));
//# sourceMappingURL=WallItemArSessionStatus.js.map